@let showSkeleton = isLoading();
@let showEmpty = !isLoading() && rows().length === 0;

@if (showEmpty && !compact()) {
  <bn-web-ui-not-available
    data-e2e="EventLogsEmptyState"
    [options]="{ height: 'initial', title: 'No events found', description: 'There are no Shield events for the selected time range and filters.' }" />
} @else if (showEmpty && compact()) {
  <div class="bn-event-logs-table__nested-empty">No events in this group.</div>
} @else {
  <div class="bn-table bn-table--auto bn-table--primary bn-event-logs-table">
    <table class="bn-table--normal">
      <thead>
        <th></th>
        <th class="whitespace-nowrap">Time</th>
        <th class="whitespace-nowrap">Action</th>
        <th class="whitespace-nowrap">Remote IP</th>
        <th class="whitespace-nowrap">Rule</th>
        <th class="whitespace-nowrap">Message</th>
        <th class="whitespace-nowrap">Request</th>
        <th></th>
      </thead>
      <tbody>
        @if (!showSkeleton) {
          @for (row of rows(); track row.logId ?? $index) {
            @let fields = fieldsOf(row);
            <tr
              class="cursor-pointer color-dark-7"
              data-e2e="EventLogRow"
              (click)="onRowToggle(row.logId ?? '')">
              <td>
                <fa-icon [icon]="openRows[row.logId ?? ''] ? 'chevron-up' : 'chevron-down'" />
              </td>
              <td class="text-nowrap">
                <div class="bn-event-logs-table__time">
                  <span>{{ row.timestamp | date: 'HH:mm:ss' }}</span>
                  <span class="bn-event-logs-table__date">{{ row.timestamp | date: 'MMM d' }}</span>
                </div>
              </td>
              <td>
                <bn-web-ui-badge
                  contentClass="text-uppercase"
                  size="sm"
                  type="tag"
                  [color]="actionColor(fields['action'])"
                  >{{ fields['action'] || '—' }}</bn-web-ui-badge
                >
              </td>
              <td>
                <div class="d-flex align-items-center gap-2 text-nowrap">
                  <bn-web-ui-flag [countryCode]="fields['country']" />
                  <span class="bn-event-logs-table__mono">{{ fields['ip'] }}</span>
                </div>
              </td>
              <td class="text-nowrap">
                <span class="bn-event-logs-table__rule">
                  <fa-icon
                    class="bn-event-logs-table__feature"
                    [icon]="featureIcon(fields['feature'])" />
                  <span class="bn-event-logs-table__rule-id">{{ fields['ruleId'] }}</span>
                </span>
              </td>
              <td
                class="simple-ellipsis"
                containerClass="mb-1"
                [tooltip]="messageOf(row)">
                {{ messageOf(row) }}
              </td>
              <td class="bn-event-logs-table__request">
                <div class="bn-event-logs-table__request-inner">
                  @if (fields['method']; as method) {
                    <bn-web-ui-badge
                      contentClass="text-uppercase"
                      size="sm"
                      type="tag"
                      [color]="methodColor(method) === 'light' ? '' : methodColor(method)"
                      >{{ method }}</bn-web-ui-badge
                    >
                  }
                  @if (fields['url']; as url) {
                    <span
                      class="bn-event-logs-table__url"
                      containerClass="mb-1"
                      [tooltip]="url"
                      >{{ url }}</span
                    >
                  }
                </div>
              </td>
              <td class="bn-event-logs-table__actions">
                @if (fields['ruleId'] && fields['feature'] === 'WAF') {
                  <bn-web-ui-dropdown-menu
                    [aboveLoader]="true"
                    [items]="ruleMenuItems(fields['ruleId'])"
                    [options]="{ align: 'end', closeOnItemClick: true, size: 'sm' }"
                    (click)="$event.stopPropagation()"
                    (clickAction)="onRuleAction($event)">
                    <div trigger>
                      <button
                        aria-label="Rule actions"
                        bn-web-ui-button
                        data-e2e="EventLogRuleMenu"
                        itemStyle="invisible"
                        [isSquare]="true">
                        <fa-icon
                          icon="ellipsis"
                          size="lg" />
                      </button>
                    </div>
                  </bn-web-ui-dropdown-menu>
                }
              </td>
            </tr>

            @if (openRows[row.logId ?? '']) {
              <tr class="no-hover">
                <td colspan="8">
                  <app-app-shield-event-logs-row-detail [row]="row" />
                </td>
              </tr>
            }
          }
        }

        @if (showSkeleton) {
          <ng-template *ngTemplateOutlet="skeletonTemplates.logsSkeletonTemplate(); context: { columns: 8 }" />
        }
      </tbody>
    </table>
  </div>
}

<bn-web-ui-table-skeleton-template #skeletonTemplates />
